import TableState from "./TableState";

export default function Table({
  columns,
  rows = [],
  loading = false,
  error = false,
  idle = false,
  onRetry,
  onEdit,
  onDelete,
  onShow,
  onCustomFunction,
  customFunctionName,
  canCustomFunction = () => true,
  notFoundMessage,
}) {

  return (
    <div data-list-start className="relative overflow-x-auto shadow-md sm:rounded-lg mt-6" aria-busy={loading}>
      {(loading || (!error && !idle && rows.length > 0)) ? (
        <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
          <thead className="text-md text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
            <tr>
              {columns &&
                columns.map((item, index) => {
                  return (
                    <th key={index} scope="col" className="px-6 py-3">
                      {item.title}
                    </th>
                  );
                })}
              {(onEdit || onDelete || onShow || onCustomFunction) && (
                <th scope="col" className="px-6 py-3">
                  عملیات
                </th>
              )}
            </tr>
          </thead>
          <tbody>
            {loading ? Array.from({ length: 5 }, (_, rowIndex) => (
              <tr key={rowIndex} aria-hidden="true" className="border-b border-slate-100 dark:border-slate-800">
                {Array.from({ length: columns.length + (onEdit || onDelete || onShow || onCustomFunction ? 1 : 0) }, (_, index) => (
                  <td key={index} className="px-6 py-5"><div className="h-4 min-w-[60px] rounded bg-slate-200 dark:bg-slate-700 motion-safe:animate-pulse" /></td>
                ))}
              </tr>
            )) : rows &&
              rows?.map((item, index) => {
                return (
                  <tr
                    key={index}
                    className="odd:bg-white odd:dark:bg-gray-900 even:bg-gray-50 even:dark:bg-gray-800 border-b dark:border-gray-700"
                  >
                    {columns.map((ColItem, index) => {
                      return (
                        <td key={index} className="px-6 py-4">
                          {item[`${ColItem.value}`]}
                        </td>
                      );
                    })}
                    {(onEdit || onDelete || onShow || onCustomFunction) && (
                      <td className="px-6 py-4 flex item-center gap-x-2">
                        {onEdit && (
                          <p
                            onClick={() => onEdit(item)}
                            className="font-medium cursor-pointer text-blue-600 dark:text-blue-500 hover:underline"
                          >
                            ویرایش
                          </p>
                        )}

                        {onCustomFunction && canCustomFunction(item) && (
                          <p
                            onClick={() => onCustomFunction(item)}
                            className="font-medium cursor-pointer text-green-600 dark:text-green-500 hover:underline"
                          >
                            {customFunctionName || "عملیات"}
                          </p>
                        )}

                        {onDelete && (
                          <p
                            onClick={() => onDelete(item)}
                            className="font-medium cursor-pointer text-red-600 dark:text-red-500 hover:underline"
                          >
                            حذف
                          </p>
                        )}
                        {onShow && (
                          <p
                            onClick={() => onShow(item)}
                            className="font-medium cursor-pointer text-purple-600 dark:text-purple-500 hover:underline"
                          >
                            نمایش
                          </p>
                        )}
                      </td>
                    )}
                  </tr>
                );
              })}
          </tbody>
        </table>
      ) : (
        <TableState error={error} idle={idle} onRetry={onRetry} message={notFoundMessage} />
      )}
      {loading && <div className="py-3 text-center text-sm text-slate-500 dark:text-slate-300" role="status">در حال دریافت اطلاعات…</div>}
    </div>
  );
}
